import { create } from 'zustand';

import type { PlatformAdmin } from '@/lib/auth-api';
import { sessionStore } from '@/lib/session-storage';

interface AuthState {
  accessToken: string | null;
  admin: PlatformAdmin | null;
  /** Session coupée par un 401 (jeton expiré, admin suspendu) plutôt que par un logout : /login l'annonce. */
  sessionExpired: boolean;
  setAuth(accessToken: string, admin: PlatformAdmin): void;
  setAdmin(admin: PlatformAdmin): void;
  clearAuth(opts?: { expired?: boolean }): void;
}

const initial = sessionStore.get();

export const useAuthStore = create<AuthState>((set, get) => ({
  accessToken: initial?.accessToken ?? null,
  admin: initial?.admin ?? null,
  sessionExpired: false,
  setAuth(accessToken, admin) {
    sessionStore.set({ accessToken, admin });
    set({ accessToken, admin, sessionExpired: false });
  },
  // Profil relu par /whoami : le jeton ne change pas
  setAdmin(admin) {
    const { accessToken } = get();
    if (accessToken) sessionStore.set({ accessToken, admin });
    set({ admin });
  },
  clearAuth(opts) {
    sessionStore.clear();
    set({ accessToken: null, admin: null, sessionExpired: opts?.expired ?? false });
  },
}));
